import { Spinner as BaseSpinner } from "tamagui";

import { ColorToken, ColorTokenValues } from "@/ui/theme/tokens";

type SpinnerSize = "large" | "small";
interface SpinnerProps {
  color?: ColorToken;
  size?: SpinnerSize;
}

const Spinner = ({ color = ColorToken.Primary100, size }: SpinnerProps) => {
  const spinnerColor = ColorTokenValues[color];

  return <BaseSpinner color={spinnerColor} size={size} />;
};

export type { SpinnerProps, SpinnerSize };
export default Spinner;
